import { connect } from 'react-redux';
import TableauDashboard from './tableau-dashboard';
import { instantiateDashboard, fetchTableauToken } from '../../actions/analytics';
import { authenticationChannel, commonActions, sessionManagement } from '@codametrix/ui-common';
const { activityMonitor } = sessionManagement;
const mapStateToProps = function(state) {
    const { analytics, ui } = state;
    return {
        ...analytics,
        serviceLine: ui.serviceLine,
        activeHealthSystemCode: ui.context.activeHealthSystemCode ?? '',
        activeDashboardResource: analytics.activeDashboardResource,
        dashboardPaths: analytics.dashboardPaths
    };
};
const mapDispatchToProps = (dispatch)=>{
    return {
        instantiateDashboard: (serviceLine)=>{
            dispatch(fetchTableauToken(serviceLine));
            dispatch(instantiateDashboard());
        },
        registerActivity: ()=>{
            activityMonitor.isActive = true;
            authenticationChannel.postMessage({
                type: commonActions.AuthenticatedWindow.ACTIVITY,
                payload: true,
                meta: {
                    suppressRedux: true
                }
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TableauDashboard);
